"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyJSON = exports.parseJSON = exports.isValidJSON = exports.isFunction = exports.isEmptyString = exports.isEmptyObject = exports.isEmpty = exports.getValueFromObject = exports.getNumberOrDefault = exports.getDomain = exports.extend = exports.containsKey = void 0;
var _ = require("lodash");
var Helper = require("firefly-utilities-helper-ts");
var log = require("loglevel");
var firefly_properties_1 = require("./constants/firefly-properties");
function containsKey(obj, key) {
    return Helper.isObject(obj) && obj.hasOwnProperty(key);
}
exports.containsKey = containsKey;
function extend(src, obj) {
    return _.merge(src, obj);
}
exports.extend = extend;
function getDomain() {
    var domain = '.target.com';
    var hostname = window.location.hostname;
    if (Helper.isString(hostname) && !Helper.isEmptyString(hostname)) {
        var browserDomain = hostname.slice(hostname.indexOf("."));
        if (domain !== browserDomain) {
            domain = browserDomain;
        }
    }
    return domain;
}
exports.getDomain = getDomain;
function getNumberOrDefault(data) {
    var result = 0;
    if (typeof data === "string") {
        result = parseInt(data, firefly_properties_1.default.RADIX_DECIMAL);
        if (isNaN(result)) {
            result = 0;
        }
    }
    if (typeof data === "number") {
        result = data;
    }
    return result;
}
exports.getNumberOrDefault = getNumberOrDefault;
function getValueFromObject(obj, key, defaultVal) {
    return _.get(obj, key, defaultVal);
}
exports.getValueFromObject = getValueFromObject;
function isEmpty(obj) {
    return _.isEmpty(obj);
}
exports.isEmpty = isEmpty;
function isEmptyObject(obj) {
    return Helper.isObject(obj) && isEmpty(obj);
}
exports.isEmptyObject = isEmptyObject;
function isEmptyString(obj) {
    return obj === "";
}
exports.isEmptyString = isEmptyString;
function isFunction(obj) {
    return _.isFunction(obj);
}
exports.isFunction = isFunction;
function isValidJSON(obj) {
    try {
        var result = parseJSON(obj);
        if (Helper.isObject(result)) {
            return true;
        }
    }
    catch (error) {
        log.error(error.message);
    }
    return false;
}
exports.isValidJSON = isValidJSON;
function parseJSON(obj) {
    return JSON.parse(obj);
}
exports.parseJSON = parseJSON;
function stringifyJSON(obj) {
    return JSON.stringify(obj);
}
exports.stringifyJSON = stringifyJSON;
